import JSEncrypt from 'jsencrypt'
import axios from '@/utils/axios.js'

let cachedPublicKey = null

/**
 * 获取 RSA 公钥（带缓存）
 * @returns {Promise<string>} Base64 编码的公钥
 */
export async function getPublicKey() {
  if (cachedPublicKey) {
    return cachedPublicKey
  }
  const { data } = await axios.get('/auth/publicKey')
  cachedPublicKey = data.data
  return cachedPublicKey
}

/**
 * 使用 RSA 公钥加密密码
 * @param {string} password 明文密码
 * @returns {Promise<string>} 加密后的 Base64 字符串
 */
export async function encryptPassword(password) {
  const publicKey = await getPublicKey()
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  const encrypted = encrypt.encrypt(password)
  if (!encrypted) {
    throw new Error('RSA encryption failed')
  }
  return encrypted
}
